import { MapPin, CalendarDays, Wallet, PlaneTakeoff, Info } from "lucide-react";
import { T, useLang } from "@/i18n";

export const TripSummary = ({ summary = {} }) => {
  const { t } = useLang();
  const items = [
    { icon: MapPin, label: "Destinazione", value: [summary.destination, summary.country].filter(Boolean).join(", "), id: "summary-destination" },
    { icon: CalendarDays, label: "Giorni", value: summary.days ? t(Number(summary.days) === 1 ? "{n} giorno" : "{n} giorni", { n: summary.days }) : "—", id: "summary-days" },
    { icon: Wallet, label: "Budget", value: summary.budget || "—", id: "summary-budget" },
    { icon: PlaneTakeoff, label: "Partenza", value: summary.departure || "—", id: "summary-departure" },
  ];
  return (
    <div data-testid="trip-summary-card" className="print-break rounded-3xl bg-gray-900 p-8 text-white md:p-10">
      <p className="text-xs font-semibold uppercase tracking-widest text-emerald-300"><T>Riepilogo del viaggio</T></p>
      <h2 className="mt-3 font-display text-3xl font-bold tracking-tight lg:text-4xl">{summary.destination}</h2>
      {summary.travel_style && <p className="mt-2 text-white/70">{summary.travel_style}{summary.period ? ` · ${summary.period}` : ""}</p>}
      <div className="mt-8 grid grid-cols-2 gap-6 lg:grid-cols-4">
        {items.map(({ icon: Icon, label, value, id }) => (
          <div key={id} data-testid={id}>
            <p className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/50"><Icon className="h-3.5 w-3.5 text-emerald-300" /><T>{label}</T></p>
            <p className="mt-2 font-display text-lg font-semibold">{value}</p>
          </div>
        ))}
      </div>
      {summary.assumptions?.length > 0 && (
        <div className="mt-8 flex gap-3 rounded-2xl bg-white/5 p-4 text-sm text-white/70">
          <Info className="mt-0.5 h-4 w-4 shrink-0 text-emerald-300" />
          <p><T>Ipotesi</T>: {summary.assumptions.join(" · ")}</p>
        </div>
      )}
    </div>
  );
};
